export enum Route {
  ADD_MOBILE = '/add-mobile',
  ADD_PAYMENT_METHOD = '/add-payment-method',
  // Apple Pay Later flow-specific routes (no base equivalents)
  ADJUST_AMOUNT = '/apple-paylater/adjust-amount',
  APPLE_PAYLATER_ADD_CARD = '/apple-paylater/add-card',
  APPLE_PAYLATER_INITIALISE = '/apple-paylater/initialise',
  APPLE_PAYLATER_INITIAL_LOADING = '/apple-paylater/initial-loading',
  CARD_EDUCATION = '/apple-paylater/card-education',
  // Apple Pay Later flow variants of base routes (keep in sync with base entries below)
  APPLE_PAYLATER_ADD_PAYMENT_METHOD = '/apple-paylater/add-payment-method',
  APPLE_PAYLATER_CARD_SCAN = '/apple-paylater/card-scan',
  APPLE_PAYLATER_CASH_AUTH = '/apple-paylater/cash-auth',
  APPLE_PAYLATER_CONTRACT_AGREEMENT = '/apple-paylater/contract-agreement',
  APPLE_PAYLATER_CREATE_PASSWORD = '/apple-paylater/create-password',
  APPLE_PAYLATER_EDIT_SHIPPING_ADDRESS_WITH_ID = '/apple-paylater/edit-shipping-address/[id]',
  APPLE_PAYLATER_KYC_CONFIRM_DETAILS = '/apple-paylater/kyc-profile-confirm-details',
  APPLE_PAYLATER_KYC_UPDATE_ADDRESS = '/apple-paylater/kyc-profile-confirm-details/update-address',
  APPLE_PAYLATER_LOGGED_IN = '/apple-paylater/logged-in',
  APPLE_PAYLATER_LOGIN = '/apple-paylater/login',
  APPLE_PAYLATER_LOGIN_ONE_TIME_CODE = '/apple-paylater/login-one-time-code',
  APPLE_PAYLATER_NEW_PAYMENT_METHOD = '/apple-paylater/new-payment-method',
  APPLE_PAYLATER_NEW_SHIPPING_ADDRESS = '/apple-paylater/new-shipping-address',
  APPLE_PAYLATER_OH_NO = '/apple-paylater/oh-no',
  APPLE_PAYLATER_PASSWORD = '/apple-paylater/password',
  APPLE_PAYLATER_PAYMENT_METHOD = '/apple-paylater/payment-method',
  APPLE_PAYLATER_PAYMENT_OPTIONS = '/apple-paylater/payment-options',
  APPLE_PAYLATER_PAYMENT_TYPES = '/apple-paylater/payment-types',
  APPLE_PAYLATER_PREFERRED_PAYMENT_DAY = '/apple-paylater/preferred-payment-day',
  APPLE_PAYLATER_RETRY_VERIFY_LICENCE = '/apple-paylater/verify-identity/retry/licence',
  APPLE_PAYLATER_RETRY_VERIFY_MEDICARE = '/apple-paylater/verify-identity/retry/medicare',
  APPLE_PAYLATER_RETRY_VERIFY_PASSPORT = '/apple-paylater/verify-identity/retry/passport',
  APPLE_PAYLATER_SHIPPING_ADDRESS = '/apple-paylater/shipping-address',
  APPLE_PAYLATER_SIGN_UP = '/apple-paylater/sign-up',
  APPLE_PAYLATER_SUMMARY = '/apple-paylater/summary',
  APPLE_PAYLATER_UNSUITABILITY_QUESTION_FORM = '/apple-paylater/unsuitability-questions/form',
  APPLE_PAYLATER_VERIFY_ADDRESS = '/apple-paylater/verify-identity/address',
  APPLE_PAYLATER_VERIFY_BIOMETRIC_PERSONA = '/apple-paylater/verify-identity/biometric/persona',
  APPLE_PAYLATER_VERIFY_CHALLENGE = '/apple-paylater/verify-challenge',
  APPLE_PAYLATER_VERIFY_IDENTITY = '/apple-paylater/verify-identity',
  APPLE_PAYLATER_VERIFY_IDENTITY_START = '/apple-paylater/verify-identity-start',
  APPLE_PAYLATER_VERIFY_LICENCE = '/apple-paylater/verify-identity/licence',
  APPLE_PAYLATER_VERIFY_MEDICARE = '/apple-paylater/verify-identity/medicare',
  APPLE_PAYLATER_VERIFY_PASSPORT = '/apple-paylater/verify-identity/passport',
  APPLE_PAYLATER_VERIFY_RETRY = '/apple-paylater/verify-retry',
  APPLE_PAYLATER_VERIFYING_BIOMETRIC = '/apple-paylater/verify-identity/biometric/verifying',
  CASH_AUTH = '/cash-auth',
  CASH_AUTH_INLINE = '/cash-auth-inline',
  CASH_APP_PAY_REMEDIATION = '/cash-app-pay-remediation',
  CASH_APP_PAY_UNAVAILABLE = '/cash-app-pay-unavailable',
  CREATE_PASSWORD = '/create-password',
  ENTER_EMAIL = '/login',
  ENTER_PASSWORD = '/password',
  NEW_PAYMENT_METHOD = '/new-payment-method',
  NEW_SHIPPING_ADDRESS = '/new-shipping-address',
  EDIT_SHIPPING_ADDRESS = '/edit-shipping-address',
  EDIT_SHIPPING_ADDRESS_WITH_ID = '/edit-shipping-address/[id]',
  ONE_TIME_PASSWORD = '/login-one-time-code',
  PAY = '/pay',
  PAY_MONTHLY = '/pay-monthly',
  PAY_MONTHLY_ONLY = '/pay-monthly-only',
  PAYMENT_METHOD = '/payment-method',
  PAYMENT_OPTIONS = '/payment-options',
  PAYMENT_TYPES = '/payment-types',
  PREFERRED_PAYMENT_DAY = '/preferred-payment-day',
  LOGGED_IN = '/logged-in',
  SHIPPING_ADDRESS = '/shipping-address',
  SIGN_UP = '/sign-up',
  SUMMARY = '/summary',
  TERMINAL_ERROR = '/oh-no',
  VERIFY = '/verify',
  VERIFY_CHALLENGE = '/verify-challenge',
  VERIFY_IDENTITY = '/verify-identity',
  VERIFY_LICENCE = '/verify-identity/licence',
  VERIFY_MEDICARE = '/verify-identity/medicare',
  VERIFY_PASSPORT = '/verify-identity/passport',
  VERIFY_ADDRESS = '/verify-identity/address',
  VERIFY_BIOMETRIC_LICENCE = '/verify-identity/biometric/licence',
  VERIFY_BIOMETRIC_PASSPORT = '/verify-identity/biometric/passport',
  VERIFYING_BIOMETRIC = '/verify-identity/biometric/verifying',
  VERIFY_BIOMETRIC_PERSONA = '/verify-identity/biometric/persona',
  VERIFY_IDENTITY_START = '/verify-identity-start',
  RETRY_VERIFY_LICENCE = '/verify-identity/retry/licence',
  RETRY_VERIFY_PASSPORT = '/verify-identity/retry/passport',
  RETRY_VERIFY_MEDICARE = '/verify-identity/retry/medicare', // only being used in unit test
  VERIFY_RETRY = '/verify-retry',
  CARD_SCAN = '/card-scan',
  PASSWORD_RESET_REQUIRED = '/password-reset-required',
  AMOUNT_TOO_HIGH = '/oh-no/amount_too_high',
  ORDER_LIMIT_EXCEEDED = '/oh-no/max_active_orders_reached',
  OVERDUE_PAYMENTS_CHECKOUT_PAYMENT_ELIGIBLE = '/oh-no/overdue_payments_checkout_payment_eligible',
  RETRY_CREDIT_FREEZE = '/retry-credit-freeze',
  INDEX = '/',
  INITIAL_LOADING = '/initial-loading',
  KYC_CONFIRM_DETAILS = '/kyc-profile-confirm-details',
  KYC_UPDATE_ADDRESS = '/kyc-profile-confirm-details/update-address',
  UNSUITABILITY_QUESTION_FORM = '/unsuitability-questions/form',
  AFFORDABILITY_QUESTION_FORM = '/affordability-questions/form',
  GET_STARTED = '/onboarding/get-started',
  CONTRACT_AGREEMENT = '/contract-agreement',
  EDUCATION_INTRO = '/education-intro',
  PROFILE_CREATED = '/profile-created',
  WELCOME_WITH_INITIAL_LIMIT = '/welcome-with-initial-limit',
}

export const isRoute = (a: unknown): a is Route => Object.values(Route).includes(a as Route)
